function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("path", {
  fill: "#425CD4",
  fillRule: "nonzero",
  d: "M11.9078947,4 C14.705653,4 16.9736842,6.2680312 16.9736842,9.06578947 C16.9736842,11.1178966 15.7534907,12.8850123 13.9990582,13.681182 C16.4442319,14.3973777 18.3879112,16.4000859 18.9753524,19.0023161 C19.0955595,19.534806 18.7644339,20.0646253 18.2357627,20.1857007 C17.7070914,20.3067761 17.1810716,19.9732587 17.0608645,19.4407688 C16.5236376,17.0609766 14.4230325,15.372272 12,15.372272 C9.57696748,15.372272 7.47636244,17.0609766 6.93913553,19.4407688 C6.81892843,19.9732587 6.2929086,20.3067761 5.76423734,20.1857007 C5.23556609,20.0646253 4.90444047,19.534806 5.02464757,19.0023161 C5.60331983,16.4389305 7.49804205,14.4573018 9.89242682,13.7137347 C8.09743857,12.9354832 6.84210526,11.1472357 6.84210526,9.06578947 C6.84210526,6.2680312 9.11013646,4 11.9078947,4 Z M11.9078947,5.9516554 C10.188006,5.9516554 8.79376066,7.34590071 8.79376066,9.06578947 C8.79376066,10.7856782 10.188006,12.1799236 11.9078947,12.1799236 C13.6277835,12.1799236 15.0220288,10.7856782 15.0220288,9.06578947 C15.0220288,7.34590071 13.6277835,5.9516554 11.9078947,5.9516554 Z"
}));
function SvgBezoekenAbsoluutUnselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBezoekenAbsoluutUnselected);
export default __webpack_public_path__ + "static/media/BezoekenAbsoluut_unselected.5e982dc9ffd2e4b063c882577b4f6671.svg";
export { ForwardRef as ReactComponent };